/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import ConfirmationModal from 'components/ConfirmationModal';

import { addModal } from 'config/modals/registry';

const launchConfirmationModal = addModal('ConfirmationModal', ConfirmationModal);

export default launchConfirmationModal;